<div class="change-plan-page" *ngIf="!nextCycleSelected">
  <div class="header-section">
    <h1 class="header">Need a replacement plan?</h1>
    <h4 class="sub-header">It has never been easier to switch!</h4>
    <div class="current-plan-details" *ngIf="!!selectedPlanInfo">
      <p class="title smaller">Your current plan details:</p>
       <div class="plan-details">
        <div class="left-details">
          <div class="plan-img" *ngIf="selectedPlanInfo?.data > 0">
            <p class="data-size">{{selectedPlanInfo?.data / 1024}}</p>
            <p class="caption">GB</p>
          </div>
          <div class="plan-img tt" *ngIf="selectedPlanInfo?.data <= 0">
            <p class="footer"><b>Talk & Text</b></p>
          </div>
          <div>
            <p class="plan-title smaller">{{selectedPlanInfo?.title}}</p>
          </div>
        </div>
        <div class="right-details">
          <sup class="dollar">$</sup>
          <h3>{{!!selectedPlanInfo?.subscriptionCycles &&
            selectedPlanInfo?.subscriptionCycles > 1 ? selectedPlanInfo?.price *
            selectedPlanInfo?.subscriptionCycles :selectedPlanInfo?.price }}</h3>
          <p class="smaller mo" *ngIf="selectedPlanInfo?.subscriptionCycles <= 1 ">/mo</p>
        </div>
      </div>
    </div>

    <div class="change-note">
      <img src="assets\icon\timer-primary.svg" alt="timer" height="54" width="54" loading="lazy">
      <p class="smaller">Please note that changing your plan might take a few moments to process.</p>
    </div>
  </div>

  <div class="other-plans-section">
    <h2 class="title">Changing Your Plan:</h2>
    <h5 class="sub-title">Select your replacement plan here and then choose when to switch:</h5>
    <div class="subscription-months-part">
      <ng-container *ngFor="let item of subscriptionCycles">
        <div class="subscription-container" (click)="selectSubscription(item)"
          [class.selected]="item === selectedSubscription" [class.third-order]="item === 1">
          <p class="val desktop"><b>{{item}}-Month</b></p>
          <p class="val mobile"><b>{{item}}-Mo</b></p>
          <img src="/assets/icon/down-primary-arrow.svg" alt="Arrow" width="55" height="20" class="primary-arrow-down"
            *ngIf="item === selectedSubscription">
        </div>
      </ng-container>
    </div>
    <div class="plan-cards-part">
      <div class="offer-banner" *ngIf="selectedSubscription === 3">
        <img src="assets/icon/celebration.svg" alt="celebration" width="32" height="32" />
        <div class="card-content">
          <h5>Good news!</h5>
          <p class="smaller">You may be eligible for our introductory offer. 
            Add to cart to check!</p>
        </div>
      </div>
      <div class="change-plan-swiper-container swiper-container">

        <div class="swiper-wrapper" [ngClass]="{odd: cyclePlans?.length % 2 !== 0}">
          <ng-container *ngFor="let plan of cyclePlans; let i = index;">
            <div class="swiper-slide" [ngClass]="{last: cyclePlans?.length - 1 === i}">
              <div class="internal-card-padding">
                <div class="card-header">
                  <div class="data">
                    <p class="plan-data" [ngClass]="{unlimited: plan?.details?.data/1024 === 30}" *ngIf="plan?.details?.data > 0">{{
                        plan?.details?.data/1024 < 1 ?
                        plan?.details?.data :
                        (plan?.details?.data/1024 === 30? 'UNLTD.' : plan?.details?.data/1024 )
                      }}<b class="data-unit">{{plan?.details?.data/1024 < 1 ? 'MB' : (plan?.details?.data/1024===30? '' : 'GB' )}}</b>
                    </p>
                    <h4 class="plan-data unlimited" *ngIf="plan?.details?.data<=0">Talk & Text</h4>
                    <p class="caption" *ngIf="plan?.details?.data > 0">Premium 5G Data</p>
                  </div>
                  <div class="price">
                    <p class="plan-card-price"><sup class="dollar">$</sup>{{plan?.price}}</p>
                    <p class="caption">Per month</p>
                  </div>
                </div>

                <p class="disclaimer footer">Subscription will auto renew at <b>${{plan?.price *
                    plan?.subscriptionCycles}}</b> +
                  applicable taxes & fees.
                </p>

                <div class="subtotal-holder">
                  <p class="subtotal smaller">Subtotal: </p>
                  <p class="text-bold"> ${{plan?.price * plan?.subscriptionCycles}}</p>
                </div>

                <div class="action">
                  <button class="button primary" (click)="changePlan(plan)" id="add-{{plan?.id}}-to-cart">
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="grantees">
          <p class="smallest">
            <img class="check-icon" src="assets\icon\yellow-tick.svg" alt="yellow check" height="14" width="16" loading="lazy"> High-speed data
          </p>
          <p class="smallest">
            <img class="check-icon" src="assets\icon\yellow-tick.svg" alt="yellow check" height="14" width="16" loading="lazy"> Unlimited talk & text
          </p>
          <p class="smallest">
            <img class="check-icon" src="assets\icon\yellow-tick.svg" alt="yellow check" height="14" width="16" loading="lazy"> Nationwide coverage.
          </p>
        </div>
        <div class="hand-swiper">
          <img src="/assets/icon/hand-swipe.svg" alt="Hand Swipe Icon" width="32" height="32">
          <p class="swipe-note caption"><b>Swipe right & left</b></p>
        </div>
        <ul class="slick-dots plan-dots slider-pagination"></ul>
      </div>
    </div>
  </div>
  <div class="disclosure">
    <p class="footer">Unless you choose to add-on high-speed data, speeds may be reduced to a maximum of 128Kbps</p>
    <p class="footer middle">if you exceed your plan’s monthly high speed data allowance. Actual speed varies by device and location.</p>
    <p class="footer">For more information on  FreeUp’s Broadband service, visit </p>
    <a (click)="redirectToDisclosure()"><p class="smallest broadband">Broadband Disclosure</p></a>
  </div>
</div>
<ng-container *ngIf="!!nextCycleSelected"> 
  <app-change-plan-summary [nextCycle]="nextCycle" [selectedUserPlan]="selectedPlan" [selectedMobilePlan]="newPlan" (backToMain)="back()"></app-change-plan-summary>
</ng-container>